import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConversationMessages } from '../../../reservation.model';

@Component({
	selector: 'app-reservation-message-details-dialog',
	templateUrl: './reservation-message-details-dialog.component.html',
	styleUrls: ['./reservation-message-details-dialog.component.scss'],
})
export class ReservationMessageDetailsDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public dialogData: ConversationMessages,
		public dialogRef: MatDialogRef<ReservationMessageDetailsDialogComponent>,
	) {}
}
